module.exports = __webpack_public_path__ + "img/logo-white.d1df157e.png";